import request from '@/axios'
import type { LoginReq, RegisterReq, SendSmsReq, UserInfo } from './types'

// ========== 认证相关 ==========

/**
 * 发送短信验证码
 * GET /User/Login/TextMessage（Query 传参）
 */
export const sendSmsCodeApi = (data: SendSmsReq): Promise<IResponse<null>> => {
  return request.get({ url: '/User/Login/TextMessage', params: data })
}

/**
 * 用户登录
 * POST /User/Login/Login（Query 传参）
 */
export const loginApi = (data: LoginReq): Promise<IResponse<{ token: string; userInfo: UserInfo }>> => {
  return request.post({ url: '/User/Login/Login', params: data })
}

/**
 * 用户注册
 * POST /User/User/Register（Body JSON + Query Code）
 * 后端签名: Register([FromBody] UserModel model, [FromQuery] string Code)
 */
export const registerApi = (data: RegisterReq): Promise<IResponse<null>> => {
  const { code, ...bodyData } = data
  return request.post({ url: '/User/User/Register', data: bodyData, params: { Code: code } })
}

// ========== 用户信息相关 ==========

/**
 * 获取当前用户个人资料及统计
 * GET /User/User/GetProfile
 */
export const getProfileApi = (): Promise<IResponse<UserInfo>> => {
  return request.get({ url: '/User/User/GetProfile' })
}

/**
 * 根据 ID 获取用户信息
 * GET /User/User/GetByID
 */
export const getUserByIdApi = (id: string): Promise<IResponse<UserInfo>> => {
  return request.get({ url: '/User/User/GetByID', params: { ID: id } })
}

/**
 * 更新个人资料
 * POST /User/User/UpdateProfile
 */
export const updateProfileApi = (data: Partial<UserInfo>): Promise<IResponse<null>> => {
  return request.post({ url: '/User/User/UpdateProfile', data })
}

/**
 * 忘记密码 - 通过短信验证码重置密码
 * POST /User/User/ForgotPassword
 */
export const forgotPasswordApi = (phone: string, code: string, newPassword: string): Promise<IResponse<null>> => {
  return request.post({
    url: '/User/User/ForgotPassword',
    params: { Phone: phone, Code: code, newPassword },
  })
}

/**
 * 修改密码
 * POST /User/User/ChangePassword
 */
export const changePasswordApi = (id: string, oldPassword: string, newPassword: string, code: string): Promise<IResponse<null>> => {
  return request.post({
    url: '/User/User/ChangePassword',
    params: { ID: id, OldPassword: oldPassword, newPassword: newPassword, Code: code },
  })
}

/**
 * 更新头像
 * POST /User/User/UpdateAvatar
 */
export const updateAvatarApi = (headImg: string): Promise<IResponse<null>> => {
  return request.post({ url: '/User/User/UpdateAvatar', params: { HeadImg: headImg } })
}
